import Vue from "vue";
import Vuex from "vuex";
import scenes from './modules/scenes'
import stimulus from './modules/stimulus'
import controller from './modules/controller'
import analysisSettings from './modules/analysisSettings'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    stimulus,
    scenes,
    controller,
    analysisSettings,
  }
})

export default store
